module.exports = __webpack_public_path__ + "static/south-state-bevs-f9c97d6d3326009b63b74162e2835540.jpg";